import "./mini-bundle-block.scss";